import ApiServer from "../ApiServer.ts";
import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as libLocation from "../lib/location.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";
import * as Html from "../util/Html.ts";
import * as i18n from "../i18n.ts";
import Icons from "../svg/Icons.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"
import * as Storage from "../lib/Storage.ts";

function afterfamchange(){
  FwDatas.reset();
  //remove parameters of the page which depends on family and goto this page with the new one
  return libLocation.goTo(libLocation.getPageName(),true,true);
  //libLocation.refresh();
}
export async function changeToFamily(familyId :string){
  var family = FwDatas.getFamilies().find(fam=>fam.metaId === familyId)
  Storage.sessionSet('needsegmentidentify','true')
  amplify.publish("familyScopeChange",familyId);
  await Promise.all([
    ApiServer.famlogfamily(familyId),
    ApiServer.famsetfirst(familyId)
  ])
  await afterfamchange()
  modal.toast({
    svg:Icons.ic_checked.withColor('#4784EC'),
    text:i18n.get("familyswitch.done",family.name)
  })
}

Html.registerDom({
  async modalcreatecircle(){
    var TPL = await import("../modal/create_circle.mustache")
    modal.openDomModal(TPL,{});
  },
  changetofamily(familyid){
    changeToFamily(familyid);
  },
  acceptinvitation(iid){
    ApiServer.famacceptinvitation(iid,afterfamchange);
  },
  blockinvitation(iid){
    ApiServer.famblockinvite(iid,true,afterfamchange);
  },
  cancelinvitation(iid){
    ApiServer.famcancelinvite(iid,afterfamchange);
  },
  async invitationacceptance(iid){
    var invitation = FwDatas.getInvitations().find(inv=>inv.invitation.metaId===iid)
    var media = invitation.medias[0].pictureUrl;
    var result = await modal.askAsPromise({
      title:"familyswitch.invitetitle",
      mediaHTML:Icons.mask.mask_invit.withImageStyle(media+"&w=120&h=120&s=c","height:120px;width:auto;margin:auto;display: block;"),
      messageHTML:i18n.get("familyswitch.invitemessage",{firstName:Html.escape(invitation.inviterName),lastName:Html.escape(invitation.familyName)}),
      button:[
        {title:"familyswitch.inviteaccept", value:"accept"},
        {title:"familyswitch.invitedecline",class:"negative", value:"decline"},

      ]
    })
    if(result==='accept'){
      await ApiServer.famacceptinvitation(iid)
      amplify.publish("invitationChange")
      afterfamchange()

    }else if(result==='decline'){
      await ApiServer.famcancelinvite(iid)
      amplify.publish("invitationChange")
      afterfamchange()
    }
  }

});
ApiServer["ui.acccreatefamily"] = async function(form){
  const newName = form.name.value.toLocaleUpperCase();
  if(FwDatas.getFamilies().some(fam=>fam.name.toLocaleUpperCase()===newName)){
    if(!await modal.confirm({
      title:'errors.oops',
      message:'errors.duplicatefamilyname',
      yes:'actions.confirmandcreate',
      no:'actions.cancel',
      lottie:"images/lottie/face_with_monocle.json"
    })){
      //user cancel
      return;
    }
  }
  try{
    var familyIdLong = await ApiServer.acccreatefamily({
      name:form.name.value,
      cover:form.cover.files[0]||"/mediadefault/familyCover"
    })
    FwDatas.reset();
    FwDatas.setFamilies([]);
    amplify.publish('familyScopeChange','family/'+familyIdLong)
    libLocation.goTo(INR.URL.ENTER_HOME,true,true);
  }catch(err :any){
    modal.closeDomModal();
    if(err.code==='505' && err.rightFlag==='KO_LIMIT'){
      Html.trigger(null,'createcirclequotareached');
    }else{
      modal.alert('fw2.defaultError');
    }
  }

}

actionMenu.register({
  switchfamily(){
    var
      currentFamilyId = FwDatas.getFamily().metaId,
      families = FwDatas.getFamilies();

    var buttonfamily = families.map(family=>{
      var
        isNotif = family.wallCounter>0,
        isPremium = family.state?.premium?.fWPremiumPopup,
        icon = '';
      if(isNotif) icon = `<span class="fw-notification">${family.wallCounter}</span>`
      else if(isPremium) icon = `<icon>${Icons.premium.ic_premium_crown}</icon>`

      return `<flexrow class="${family.metaId===currentFamilyId?'selected':''}" style="margin:0 var(--space-s);border-radius:var(--space);min-width: 20vw;height:72px;padding:var(--space-xs);gap:var(--space-s);" data-fw-onclick="changetofamily|${family.metaId}">
      <img src="${family.coverUri}&w=120&h=120&s=c" style="width:48px;border-radius:12px"/>
      <flexauto>
        <line>${Html.escape(family.name)}</line>
        <line class="sub4" style="font-size:15px">${i18n.get('launchpad.member',family.members.length)}</line>
      </flexauto>
      ${icon}
    </flexrow>`
    })
    var invitations = FwDatas.getInvitations().map(invitation=>{
      return `<flexrow style="margin:0 var(--space-s);border-radius:var(--space);min-width: 20vw;height:72px;padding:var(--space-xs);gap:var(--space-s);" data-fw-onclick="invitationacceptance|${invitation.invitation.metaId}">
      <img src="${invitation.coverURI}&w=120&h=120&s=c" style="width:48px;border-radius:12px"/>
      <flexauto>
        <line>${Html.escape(invitation.familyName)}</line>
        <line class="sub4" style="font-size:15px">${i18n.get('familyswitch.pendinginvite')}</line>
      </flexauto>
      <span class="fw-notification">${i18n.get('labels.new')}</span>
      </flexrow>
      `
    })

    var menu = [
      `<p class="sub3" style="margin:0 var(--space-s);padding:var(--space-xs);pointer-events: none;">${i18n.get('familyswitch.switchcircle')}</p>`,
      ... buttonfamily,...invitations, '<hr style="margin:var(--space-xs) 0">',
      `<flexrow style="margin:0 var(--space-s);border-radius:var(--space);min-width: 20vw;height:72px;padding:var(--space-xs);gap:var(--space-s);" data-fw-onclick="modalcreatecircleonClickAction">
      <icon style="width:48px;border-radius:12px;color:var(--fwPrimary);background-color:var(--fwPrimary25);padding:8px">${Icons.ic_add_plus}</icon>
      <flexauto>
        <line>${i18n.get('familyswitch.create')}</line>
        <line class="sub4" style="font-size:15px">${i18n.get('familyswitch.createsub')}</line>
      </flexauto>
    </flexrow>`
    ]

    return {menu:menu.map(b=>{return {html:b}})}

  }
})

